import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Container, Card, Row, Col, Form, Button, Badge, Table, Spinner, Modal, Tabs, Tab } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'; // ADICIONADO PARA REDIRECIONAMENTO
import { api } from '../../services/api.js';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';
import Foto from "../Components/Foto";
import Swal from 'sweetalert2';
import { FaCheck, FaTimes, FaTruck, FaPrint, FaBoxes, FaSync, FaEye, FaEdit, FaHistory, FaUserTag, FaListAlt, FaSearch } from 'react-icons/fa';

const fotoColaboradorMemoria = new Map();

// LISTA FIXA DE DEPARTAMENTOS
const DEPARTAMENTOS_LISTA = [
    { cod: '50', nome: 'Departamento 50' },
    { cod: '52', nome: 'Departamento 52' },
    { cod: '53', nome: 'Departamento 53' },
    { cod: '54', nome: 'Departamento 54' },
    { cod: '55', nome: 'Departamento 55' },
    { cod: '56', nome: 'Departamento 56' },
    { cod: '57', nome: 'Departamento 57' },
    { cod: '58', nome: 'Departamento 58' },
    { cod: '59', nome: 'Departamento 59' },
    { cod: '60', nome: 'Departamento 60' },
    { cod: '61', nome: 'Departamento 61' },
    { cod: '64', nome: 'Departamento 64' },
    { cod: '99', nome: 'Ifood (Dep. 99)' }
];

// SANITIZAÇÃO RIGOROSA PARA REMOVER LIXO DO BANCO
const limparTextoProfundo = (str) => {
    if (!str) return '';
    return String(str)
        .replace(/ert\{\}/gi, '')
        .replace(/[{}]/g, '')
        .replace(/[^\x20-\x7E\xA0-\xFF]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
};

const formatarLoja = (loja) => {
    if (!loja) return '00';
    return String(loja).padStart(2, '0');
};

// CACHE LOCALSTORAGE DE FOTO DO EPI
const obterFotoEpiComCache = async (codGrupo) => {
    if (!codGrupo) return '';
    const chave = `epi_grupo_${codGrupo}`;
    const fotoLocal = localStorage.getItem(chave);
    if (fotoLocal) return fotoLocal;

    try {
        const res = await api.get(`/rh/epi/foto/${codGrupo}`);
        if (res?.data?.foto) {
            const fotoBase64 = `data:image/jpeg;base64,${res.data.foto}`;
            try { localStorage.setItem(chave, fotoBase64); } catch (e) { }
            return fotoBase64;
        }
    } catch (err) {
        console.error(`Erro ao carregar foto do grupo EPI ${codGrupo}`, err);
    }
    return '';
};

// COMPONENTE FOTO EPI
const FotoEpiAvatar = React.memo(({ codGrupo, descricao, onSelectFoto }) => {
    const [fotoSrc, setFotoSrc] = useState(null);

    useEffect(() => {
        if (!codGrupo) return;
        let isMounted = true;
        obterFotoEpiComCache(codGrupo).then(src => {
            if (isMounted && src) setFotoSrc(src);
        });
        return () => { isMounted = false; };
    }, [codGrupo]);

    if (!fotoSrc) return <span className="text-muted small me-2">🪖</span>;

    return (
        <img
            src={fotoSrc}
            alt={descricao}
            style={{ width: '42px', height: '42px', objectFit: 'contain', cursor: 'pointer', borderRadius: '4px' }}
            className="border p-1 bg-white me-2 shadow-sm"
            onClick={(e) => {
                e.stopPropagation();
                onSelectFoto && onSelectFoto({ foto: fotoSrc, nome: descricao, info01: `Grupo: ${codGrupo}` });
            }}
        />
    );
});

// COMPONENTE AVATAR FUNCIONÁRIO
const FotoFuncionarioAvatar = React.memo(({ chapa, nome, info01, info02, onSelectFoto }) => {
    const [fotoSrc, setFotoSrc] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!chapa) return;
        let isMounted = true;
        const chave = `func_${chapa}`;

        const fotoLocal = localStorage.getItem(chave);
        if (fotoLocal) {
            setFotoSrc(fotoLocal);
            return;
        }

        if (fotoColaboradorMemoria.has(chave)) {
            setFotoSrc(fotoColaboradorMemoria.get(chave));
            return;
        }

        setLoading(true);
        api.get(`/usuario/foto/${chapa}`)
            .then(res => {
                if (isMounted && res?.data?.foto) {
                    const src = `data:image/jpeg;base64,${res.data.foto}`;
                    fotoColaboradorMemoria.set(chave, res.data.foto);
                    try { localStorage.setItem(chave, src); } catch (e) { }
                    setFotoSrc(src);
                }
            })
            .catch(() => { })
            .finally(() => { if (isMounted) setLoading(false); });

        return () => { isMounted = false; };
    }, [chapa]);

    return (
        <div
            style={{ width: '40px', height: '48px', cursor: fotoSrc ? 'pointer' : 'default', borderRadius: '4px', overflow: 'hidden', backgroundColor: '#f0f0f0' }}
            className="d-flex align-items-center justify-content-center border"
            onClick={(e) => {
                if (e) e.stopPropagation();
                if (fotoSrc && onSelectFoto) {
                    onSelectFoto({
                        foto: fotoSrc,
                        nome: nome || "",
                        info01: info01 || `Matrícula: ${chapa}`,
                        info02: info02 || ""
                    });
                }
            }}
        >
            {loading ? (
                <Spinner animation="border" size="sm" style={{ color: '#8b0000' }} />
            ) : fotoSrc ? (
                <img src={fotoSrc} alt="Foto" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
                <span className="text-muted">👤</span>
            )}
        </div>
    );
});

export default function EpiControle() {
    const navigate = useNavigate();


    useEffect(() => {
        const permiteControleEpi = localStorage.getItem("CONTROLEEPI") === "S";
        const permiteRegional = localStorage.getItem("permiteRegional") === "S";
        const permiteDashBoardRH = localStorage.getItem("RHDASHBOARD") === "S";
        const eDiretor = localStorage.getItem("diretor") === "S";

        const temAcesso = permiteControleEpi || permiteRegional || permiteDashBoardRH || eDiretor;

        if (!temAcesso) {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Você não tem permissão para acessar o Controle de EPI.',
                confirmButtonColor: '#8b0000',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(() => {
                navigate('/arbor/home');
            });
        }
    }, [navigate]);

    const [abaAtiva, setAbaAtiva] = useState('pedidos');

    // ESTADO DAS LOJAS DA API
    const [listaLojas, setListaLojas] = useState([]);

    // ESTADOS ABA PEDIDOS
    const [pedidos, setPedidos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingSeparacao, setLoadingSeparacao] = useState(false);
    const [loja, setLoja] = useState('');
    const [status, setStatus] = useState('S');
    const [chapaFiltro, setChapaFiltro] = useState('');
    const [dataInicio, setDataInicio] = useState(new Date().toISOString().slice(0, 10));
    const [dataFim, setDataFim] = useState(new Date().toISOString().slice(0, 10));

    // ESTADOS ABA FUNCIONÁRIOS POR LOJA / DEPARTAMENTO
    const [seletorFiltro, setSeletorFiltro] = useState('');
    const [funcionariosLoja, setFuncionariosLoja] = useState([]);
    const [loadingFuncsLoja, setLoadingFuncsLoja] = useState(false);
    const [termoFiltroFunc, setTermoFiltroFunc] = useState(''); // ITEM 3: Filtro Frontend

    // MODAIS DIVERSOS
    const [showModalEpisFunc, setShowModalEpisFunc] = useState(false);
    const [funcSelecionado, setFuncSelecionado] = useState(null);
    const [episAssociados, setEpisAssociados] = useState([]);
    const [loadingEpisAssoc, setLoadingEpisAssoc] = useState(false);

    const [showModalPedido, setShowModalPedido] = useState(false);
    const [pedidoDetalhe, setPedidoDetalhe] = useState(null);
    const [loadingDetalhe, setLoadingDetalhe] = useState(false);

    // BUSCA E EDICAO DE EPI
    const [editandoCodEpi, setEditandoCodEpi] = useState(false);
    const [novoCodEpi, setNovoCodEpi] = useState('');
    const [buscaEpiTermo, setBuscaEpiTermo] = useState('');
    const [listaEpisBusca, setListaEpisBusca] = useState([]);
    const [loadingBuscaEpi, setLoadingBuscaEpi] = useState(false);
    const [qtdAprovacao, setQtdAprovacao] = useState(1);

    const [showModalLog, setShowModalLog] = useState(false);
    const [dadosLog, setDadosLog] = useState(null);
    const [loadingLog, setLoadingLog] = useState(false);

    const [showModalDespacho, setShowModalDespacho] = useState(false);
    const [pedidoSelDespacho, setPedidoSelDespacho] = useState(null);
    const [cgo, setCgo] = useState('');
    const [nota, setNota] = useState('');

    const [fotoSelecionada, setFotoSelecionada] = useState(null);

    const obterUsuarioLogado = () => {
        return localStorage.getItem('chapa') || localStorage.getItem('usuario') || localStorage.getItem('user') || 'SISTEMA';
    };

    // CARREGAR LOCALIZAÇÃO DAS LOJAS
    useEffect(() => {
        const carregarLojas = async () => {
            try {
                const res = await api.get('/lojas/localizacao');
                const dados = Array.isArray(res.data) ? res.data : [];
                const lojasAtivas = dados.filter(item => item.statusemp === 'A');
                setListaLojas(lojasAtivas);

                if (lojasAtivas.length > 0) {
                    const cod = String(Math.floor(lojasAtivas[0].cod_emp));
                    setSeletorFiltro(`LOJA_${cod}`);
                }
            } catch (err) {
                console.error('Erro ao buscar localização das lojas:', err);
            }
        };
        carregarLojas();
    }, []);

    // BUSCA PEDIDOS PRINCIPAL
    const carregarPedidos = useCallback(async () => {
        if (status !== 'S' && (!dataInicio || !dataFim)) {
            Swal.fire({
                icon: 'warning',
                title: 'Aviso',
                text: 'Informe o período de solicitação (Data Inicial e Final).',
                confirmButtonColor: '#8b0000'
            });
            return;
        }
        setLoading(true);
        try {
            const res = await api.get('/rh/epi/pedidos', {
                params: {
                    loja,
                    status,
                    chapa: chapaFiltro,
                    dataInicio: status !== 'S' ? dataInicio : '',
                    dataFim: status !== 'S' ? dataFim : ''
                }
            });
            setPedidos(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro', text: 'Falha ao carregar pedidos de EPI', confirmButtonColor: '#8b0000' });
        } finally {
            setLoading(false);
        }
    }, [loja, status, chapaFiltro, dataInicio, dataFim]);

    useEffect(() => {
        if (abaAtiva === 'pedidos') {
            carregarPedidos();
        }
    }, [carregarPedidos, abaAtiva]);

    // BUSCA FUNCIONÁRIOS DA LOJA OU DEPARTAMENTO
    const carregarFuncionariosLoja = useCallback(async () => {
        if (!seletorFiltro) return;
        setLoadingFuncsLoja(true);

        let params = {};
        if (seletorFiltro.startsWith('LOJA_')) {
            params.loja = seletorFiltro.replace('LOJA_', '');
        } else if (seletorFiltro.startsWith('DEP_')) {
            params.loja = seletorFiltro.replace('DEP_', '');
        }

        try {
            const res = await api.get('/rh/epi/funcionarios-loja', { params });
            setFuncionariosLoja(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro', text: 'Falha ao buscar colaboradores.', confirmButtonColor: '#8b0000' });
        } finally {
            setLoadingFuncsLoja(false);
        }
    }, [seletorFiltro]);

    useEffect(() => {
        if (abaAtiva === 'funcionarios') {
            carregarFuncionariosLoja();
        }
    }, [carregarFuncionariosLoja, abaAtiva]);

    // ITEM 3: FILTRO FRONTEND NA LISTAGEM DE FUNCIONÁRIOS POR NOME, CHAPA E FUNÇÃO
    const funcionariosFiltrados = useMemo(() => {
        if (!termoFiltroFunc.trim()) return funcionariosLoja;
        const termo = termoFiltroFunc.toLowerCase().trim();

        return funcionariosLoja.filter(f => {
            const nome = (f.nome || '').toLowerCase();
            const chapa = (f.chapa || '').toLowerCase();
            const funcao = (f.funcao || '').toLowerCase();
            return nome.includes(termo) || chapa.includes(termo) || funcao.includes(termo);
        });
    }, [funcionariosLoja, termoFiltroFunc]);

    // EPIS ASSOCIADOS AO FUNCIONÁRIO
    const abrirEpisAssociados = async (func) => {
        setFuncSelecionado(func);
        setShowModalEpisFunc(true);
        setLoadingEpisAssoc(true);
        try {
            const res = await api.get(`/rh/epi/associados/${func.chapa}`);
            setEpisAssociados(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro', text: 'Falha ao obter EPIs associados.', confirmButtonColor: '#8b0000' });
        } finally {
            setLoadingEpisAssoc(false);
        }
    };

    // ITEM 2: IMPRESSÃO FICHA DE EPI INDIVIDUAL (DATA DE APROVAÇÃO)
    const imprimirFichaIndividual = async (chapaFunc, dadosApoio = null) => {
        if (!chapaFunc) return;

        try {
            const chapaFormatada = String(chapaFunc).padStart(6, '0');
            let ficha = null;

            try {
                const res = await api.get(`/rh/epi/ficha/${chapaFormatada}`);
                if (res?.data) {
                    ficha = Array.isArray(res.data) ? res.data[0] : (res.data.data ? res.data.data : res.data);
                }
            } catch (e) {
                console.warn("Retorno de ficha via API indisponível. Usando montagem dinâmica.", e);
            }

            const funcRef = dadosApoio || funcSelecionado || {};
            const nomeFinal = ficha?.nome || funcRef.nome || 'COLABORADOR';
            const chapaFinal = ficha?.chapa || chapaFormatada;
            const lojaFinal = ficha?.loja || funcRef.loja || '-';
            const funcaoFinal = ficha?.funcao || funcRef.funcao || '-';
            const setorFinal = ficha?.setor || funcRef.setor || '-';
            const admissaoFinal = ficha?.data_admissao || funcRef.data_admissao || '-';
            const itensFicha = ficha?.itens_ficha || episAssociados || [];

            const win = window.open('', '_blank', 'width=900,height=700');
            if (!win) {
                Swal.fire({ icon: 'warning', title: 'Pop-up bloqueado', text: 'Permita pop-ups no navegador para emitir a ficha.', confirmButtonColor: '#8b0000' });
                return;
            }

            const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Ficha de EPI - ${nomeFinal}</title>
          <style>
            @page { size: A4 portrait; margin: 8mm; }
            body { font-family: Arial, sans-serif; font-size: 8.5pt; color: #000; margin: 0; padding: 10px; }
            .box-header { border: 1px solid #000; padding: 6px; display: flex; align-items: center; justify-content: space-between; }
            .title { font-size: 11pt; font-weight: bold; text-align: center; flex-grow: 1; }
            .field-table { width: 100%; border-collapse: collapse; margin-top: 6px; }
            .field-table td { border: 1px solid #000; padding: 4px; font-size: 8pt; }
            .termo { font-size: 7pt; text-align: justify; margin: 8px 0; line-height: 1.2; }
            .tbl-itens { width: 100%; border-collapse: collapse; margin-top: 6px; }
            .tbl-itens th, .tbl-itens td { border: 1px solid #000; padding: 4px; text-align: center; font-size: 8pt; }
            .lgpd-box { border: 1px solid #000; padding: 6px; margin-top: 12px; font-size: 7.5pt; }
          </style>
        </head>
        <body>
          <div class="box-header">
            <div style="font-weight:bold; font-size:9.5pt;">FLORESTA COMÉRCIO E INDÚSTRIA S/A</div>
            <div class="title">CONTROLE E FICHA INDIVIDUAL DE EPI'S</div>
          </div>

          <table class="field-table">
            <tr>
              <td colSpan="2"><strong>Nome:</strong> ${nomeFinal}</td>
              <td><strong>Matrícula:</strong> ${chapaFinal}</td>
              <td><strong>Admissão:</strong> ${admissaoFinal}</td>
            </tr>
            <tr>
              <td><strong>Loja:</strong> ${lojaFinal}</td>
              <td><strong>Função:</strong> ${funcaoFinal}</td>
              <td colSpan="2"><strong>Setor/Depto:</strong> ${setorFinal}</td>
            </tr>
          </table>

          <div style="font-weight:bold; text-align:center; margin-top:8px; font-size:8.5pt;">TERMO DE RESPONSABILIDADE</div>
          <div class="termo">
            1) Na condição de funcionário do Floresta Comércio e Indústria S/A, declaro ter recebido todos os equipamentos e uniformes necessários à execução segura das minhas atribuições.<br/>
            2) Declaro ter recebido orientações sobre o uso correto, guarda e conservação dos EPIs.<br/>
            3) Comprometo-me a utilizar os EPIs apenas para as finalidades destinadas.<br/>
            4) Em caso de desligamento, comprometo-me a devolver todos os itens em até 24 horas.
          </div>

          <table class="tbl-itens">
            <thead>
              <tr>
                <th style="width: 40%;">Descrição do EPI</th>
                <th style="width: 8%;">Qtd.</th>
                <th style="width: 12%;">C.A.</th>
                <th style="width: 15%;">Data Aprovação</th>
                <th style="width: 15%;">Assinatura</th>
                <th style="width: 10%;">Devolução</th>
              </tr>
            </thead>
            <tbody>
              ${itensFicha.length > 0 ? itensFicha.map(it => `
                <tr>
                  <td style="text-align:left;">${limparTextoProfundo(it.descricao || it.descricao_epi)}</td>
                  <td>${it.qtde || 1}</td>
                  <td>${limparTextoProfundo(it.ca || it.ca_epi) || '-'}</td>
                  <td>${it.data_aprovado || it.data_entrega || it.data_solicitacao || '-'}</td>
                  <td></td>
                  <td>${it.data_devolucao || ''}</td>
                </tr>
              `).join('') : `
                <tr><td colSpan="6" style="padding:10px;">Nenhum item registrado na ficha até o momento.</td></tr>
              `}
              ${Array.from({ length: Math.max(0, 6 - itensFicha.length) }).map(() => `
                <tr><td style="height:22px;"></td><td></td><td></td><td></td><td></td><td></td></tr>
              `).join('')}
            </tbody>
          </table>

          <div class="lgpd-box">
            <div style="font-weight:bold; text-align:center; margin-bottom:4px;">PRIVACIDADE DE DADOS (LGPD)</div>
            Os dados presentes nesta ficha destinam-se ao cumprimento de obrigações legais e regulamentares trabalhistas (NR-06).<br/><br/>
            <strong>Assinatura do Colaborador:</strong> _____________________________________ &nbsp;&nbsp;&nbsp;&nbsp; <strong>Data:</strong> ____/____/________
          </div>
          <script>
            window.onload = function() {
              window.print();
            };
          </script>
        </body>
        </html>
      `;
            win.document.write(html);
            win.document.close();
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro', text: 'Não foi possível carregar os dados para emissão da ficha.', confirmButtonColor: '#8b0000' });
        }
    };

    // IMPRESSÃO FICHA DE SEPARAÇÃO
    const imprimirSeparacao = async () => {
        setLoadingSeparacao(true);
        try {
            const res = await api.get('/rh/epi/separacao', { params: { loja } });
            const dadosBrutos = Array.isArray(res.data) ? res.data : [];

            if (dadosBrutos.length === 0) {
                Swal.fire({ icon: 'info', title: 'Aviso', text: 'Nenhum item solicitado para separação.', confirmButtonColor: '#8b0000' });
                setLoadingSeparacao(false);
                return;
            }

            const mapaEpis = new Map();
            dadosBrutos.forEach(item => {
                const keyEpi = item.cod_epi;
                if (!mapaEpis.has(keyEpi)) {
                    mapaEpis.set(keyEpi, {
                        cod_grupo: item.cod_grupo,
                        grupo: limparTextoProfundo(item.grupo),
                        cod_epi: item.cod_epi,
                        descricao_epi: limparTextoProfundo(item.descricao_epi),
                        ca_epi: limparTextoProfundo(item.ca_epi),
                        total_geral: 0,
                        lojas: new Map()
                    });
                }

                const epiObj = mapaEpis.get(keyEpi);
                epiObj.total_geral += Number(item.qtde || 0);

                const keyLoja = item.loja || '1';
                if (!epiObj.lojas.has(keyLoja)) {
                    epiObj.lojas.set(keyLoja, {
                        loja: keyLoja,
                        total_loja: 0,
                        colaboradores: []
                    });
                }

                const lojaObj = epiObj.lojas.get(keyLoja);
                lojaObj.total_loja += Number(item.qtde || 0);
                lojaObj.colaboradores.push({
                    chapa: item.chapa,
                    nome: item.nome_funcionario,
                    qtde: item.qtde
                });
            });

            const listaEpis = Array.from(mapaEpis.values());

            const episComFotos = await Promise.all(
                listaEpis.map(async (epi) => {
                    const foto = await obterFotoEpiComCache(epi.cod_grupo);
                    return { ...epi, foto_epi: foto };
                })
            );

            const win = window.open('', '_blank');
            const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Ficha de Separação de EPIs</title>
          <style>
            body { font-family: Arial, sans-serif; font-size: 9pt; margin: 8mm; color: #111; }
            h3 { text-align: center; color: #8b0000; margin-bottom: 2px; }
            .header-info { text-align: center; font-size: 9pt; font-weight: bold; margin-bottom: 12px; border-bottom: 2px solid #8b0000; padding-bottom: 4px; }
            .card-epi { border: 1px solid #333; margin-bottom: 12px; page-break-inside: avoid; border-radius: 4px; overflow: hidden; }
            .card-epi-header { background-color: #f2f2f2; padding: 6px 10px; display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #ccc; }
            .epi-title { font-size: 10pt; font-weight: bold; color: #000; }
            .epi-badge { background-color: #8b0000; color: #fff; padding: 3px 8px; border-radius: 4px; font-weight: bold; font-size: 10pt; }
            .tbl-detalhes { width: 100%; border-collapse: collapse; }
            .tbl-detalhes td { padding: 4px 8px; border-bottom: 1px solid #eee; }
            .tr-loja { background-color: #f9f9f9; font-weight: bold; border-top: 1px solid #ddd; }
            .txt-chapa { font-family: monospace; font-size: 8.5pt; color: #444; }
            .img-epi { width: 38px; height: 38px; object-fit: contain; margin-right: 8px; }
          </style>
        </head>
        <body>
          <h3>Ficha de Separação de EPIs Solicitados</h3>
          <div class="header-info">Loja Filtro: ${loja || 'Todas'} &nbsp;&nbsp;|&nbsp;&nbsp; Data: ${new Date().toLocaleDateString('pt-BR')} ${new Date().toLocaleTimeString('pt-BR')}</div>

          ${episComFotos.map(epi => `
            <div class="card-epi">
              <div class="card-epi-header">
                <div style="display: flex; align-items: center;">
                  ${epi.foto_epi ? `<img src="${epi.foto_epi}" class="img-epi" />` : ''}
                  <div>
                    <span class="epi-title">[Cód: ${epi.cod_epi}] ${epi.descricao_epi}</span><br/>
                    <small>Grupo: ${epi.grupo || 'Geral'} | C.A: ${epi.ca_epi || 'N/A'}</small>
                   </div>
                </div>
                <div>
                  <span class="epi-badge">${epi.total_geral}</span>
                </div>
              </div>

              <table class="tbl-detalhes">
                <tbody>
                  ${Array.from(epi.lojas.values()).map(l => `
                    <tr class="tr-loja">
                      <td colSpan="2" style="color: #8b0000;">🏢 LOJA ${formatarLoja(l.loja)}</td>
                      <td style="text-align: right; color: #8b0000;"><strong>${l.total_loja}</strong></td>
                    </tr>
                    ${l.colaboradores.map(c => `
                      <tr>
                        <td style="padding-left: 20px; width: 130px;" class="txt-chapa">Matrícula: ${c.chapa}</td>
                        <td>${c.nome || 'Colaborador'}</td>
                        <td style="text-align: right; width: 80px; font-weight: bold;">${c.qtde}</td>
                      </tr>
                    `).join('')}
                  `).join('')}
                </tbody>
              </table>
            </div>
          `).join('')}

          <script>
            window.onload = function() {
              window.print();
            };
            window.onafterprint = function() {
              window.close();
            };
            setTimeout(function() {
              window.close();
            }, 3000);
          </script>
        </body>
        </html>
      `;
            win.document.write(html);
            win.document.close();
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro', text: 'Falha ao gerar Ficha de Separação', confirmButtonColor: '#8b0000' });
        } finally {
            setLoadingSeparacao(false);
        }
    };

    const abrirModalPedido = async (pedCodigo) => {
        setLoadingDetalhe(true);
        setShowModalPedido(true);
        setEditandoCodEpi(false);
        setBuscaEpiTermo('');
        setListaEpisBusca([]);
        try {
            const res = await api.get(`/rh/epi/pedido/${pedCodigo}`);
            setPedidoDetalhe(res.data);
            setNovoCodEpi(res.data?.cod_epi || '');
            setQtdAprovacao(res.data?.qtde || 1);
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro', text: 'Não foi possível carregar os detalhes do pedido.', confirmButtonColor: '#8b0000' });
            setShowModalPedido(false);
        } finally {
            setLoadingDetalhe(false);
        }
    };

    // ITEM 1: TRATAMENTO SUAVE PARA A BUSCA DE EPIS NO FRONTEND
    const pesquisarEpis = async (termo) => {
        setBuscaEpiTermo(termo);
        if (!termo || termo.length < 2) {
            setListaEpisBusca([]);
            return;
        }
        setLoadingBuscaEpi(true);
        try {
            const res = await api.get('/rh/epi/buscar-itens', { params: { busca: termo } });
            setListaEpisBusca(Array.isArray(res.data) ? res.data : []);
        } catch (e) {
            console.warn('Backend de busca de EPIs ainda indisponível ou em implementação.', e);
            setListaEpisBusca([]);
        } finally {
            setLoadingBuscaEpi(false);
        }
    };

    const handleSalvarNovoEpi = async (codParaSalvar) => {
        const epiFinal = codParaSalvar || novoCodEpi;
        if (!epiFinal) return;

        const usuarioLogado = obterUsuarioLogado();

        try {
            await api.post('/rh/epi/substituir-item', {
                pedido: pedidoDetalhe.pedido,
                novoCodEpi: parseInt(epiFinal, 10),
                usuario: usuarioLogado
            });

            Swal.fire({ icon: 'success', title: 'Sucesso', text: 'Item alterado com sucesso!', confirmButtonColor: '#8b0000' });

            setEditandoCodEpi(false);
            abrirModalPedido(pedidoDetalhe.pedido);
            carregarPedidos();
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro', text: 'Falha ao alterar o item do pedido.', confirmButtonColor: '#8b0000' });
        }
    };

    const abrirModalLog = async (pedCodigo) => {
        setLoadingLog(true);
        setShowModalLog(true);
        try {
            const res = await api.get(`/rh/epi/log/${pedCodigo}`);
            setDadosLog(res.data);
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro', text: 'Não foi possível carregar o log do pedido.', confirmButtonColor: '#8b0000' });
            setShowModalLog(false);
        } finally {
            setLoadingLog(false);
        }
    };

    const handleAprovarNegar = async (novoStatus) => {
        try {
            await api.post('/rh/epi/status', {
                pedido: pedidoDetalhe.pedido,
                status: novoStatus,
                qtde: qtdAprovacao,
                usuario: obterUsuarioLogado()
            });
            Swal.fire({ icon: 'success', title: 'Sucesso', text: novoStatus === 'A' ? 'Pedido aprovado!' : 'Pedido negado.', confirmButtonColor: '#8b0000' });
            setShowModalPedido(false);
            carregarPedidos();
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro', text: 'Falha ao processar ação.', confirmButtonColor: '#8b0000' });
        }
    };

    const handleConfirmarDespacho = async () => {
        try {
            await api.post('/rh/epi/status', {
                pedido: pedidoSelDespacho.pedido,
                status: 'D',
                cgo,
                nota,
                usuario: obterUsuarioLogado()
            });
            Swal.fire({ icon: 'success', title: 'Sucesso', text: 'Pedido despachado com sucesso!', confirmButtonColor: '#8b0000' });
            setShowModalDespacho(false);
            carregarPedidos();
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro', text: 'Falha ao despachar pedido.', confirmButtonColor: '#8b0000' });
        }
    };

    return (
        <div className="layout-rh d-flex flex-column min-vh-100">
            <Menu modulo="ARBOR" />

            <Container className="flex-grow-1 pb-4" style={{ marginTop: '75px' }}>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 mb-3">
                    <div>
                        <h4 className="fw-bold text-dark mb-0">Gestão e Controle de EPIs</h4>
                        <p className="text-muted small mb-0">Aprovação, Despacho, Colaboradores e Fichas de Entrega</p>
                    </div>

                    <div className="d-flex gap-2">
                        {status === 'S' && abaAtiva === 'pedidos' && (
                            <Button
                                variant="outline-danger"
                                className="fw-bold btn-sm d-flex align-items-center"
                                style={{ borderColor: '#8b0000', color: '#8b0000' }}
                                onClick={imprimirSeparacao}
                                disabled={loadingSeparacao}
                            >
                                {loadingSeparacao ? (
                                    <>
                                        <Spinner animation="border" size="sm" className="me-1" style={{ color: '#8b0000' }} />
                                        Carregando Ficha...
                                    </>
                                ) : (
                                    <>
                                        <FaBoxes className="me-1" /> Ficha de Separação
                                    </>
                                )}
                            </Button>
                        )}
                    </div>
                </div>

                <Tabs activeKey={abaAtiva} onSelect={(k) => setAbaAtiva(k)} className="mb-3">
                    <Tab eventKey="pedidos" title={<><FaListAlt className="me-1" /> Pedidos e Solicitações</>}>
                        <Card className="border-0 shadow-sm mb-4">
                            <Card.Body className="p-3">
                                <Form.Label className="small fw-bold mb-2" style={{ color: '#8b0000' }}>Status do Pedido</Form.Label>
                                <div className="d-flex flex-wrap gap-3 align-items-center mb-3">
                                    {[
                                        { id: 'T', label: 'Todos' },
                                        { id: 'S', label: 'Solicitado' },
                                        { id: 'N', label: 'Negado' },
                                        { id: 'A', label: 'Autorizado' },
                                        { id: 'D', label: 'Despachado' },
                                        { id: 'E', label: 'Entregue' },
                                        { id: 'R', label: 'Recebido' },
                                        { id: 'DV', label: 'Devolvido' },
                                        { id: 'V', label: 'Vencido' },
                                    ].map(st => (
                                        <Form.Check
                                            key={st.id}
                                            inline
                                            type="radio"
                                            id={`status-${st.id}`}
                                            label={st.label}
                                            name="radioStatus"
                                            checked={status === st.id}
                                            onChange={() => setStatus(st.id)}
                                            className="small fw-semibold"
                                        />
                                    ))}
                                </div>

                                <Row className="g-2 align-items-end">
                                    <Col xs={6} md={status !== 'S' ? 2 : 3}>
                                        <Form.Label className="small fw-bold mb-1">Loja</Form.Label>
                                        <Form.Select
                                            size="sm"
                                            value={loja}
                                            onChange={e => setLoja(e.target.value)}
                                        >
                                            <option value="">Todas as Lojas</option>
                                            {listaLojas.map((l) => {
                                                const cod = Math.floor(l.cod_emp);
                                                return (
                                                    <option key={cod} value={cod}>
                                                        {l.razao || `Loja ${cod}`}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                    </Col>
                                    <Col xs={6} md={status !== 'S' ? 2 : 3}>
                                        <Form.Label className="small fw-bold mb-1">Matrícula / Chapa</Form.Label>
                                        <Form.Control size="sm" type="text" value={chapaFiltro} onChange={e => setChapaFiltro(e.target.value)} placeholder="Matrícula" />
                                    </Col>

                                    {status !== 'S' && (
                                        <>
                                            <Col xs={6} md={2}>
                                                <Form.Label className="small fw-bold mb-1">Data Início</Form.Label>
                                                <Form.Control size="sm" type="date" value={dataInicio} onChange={e => setDataInicio(e.target.value)} />
                                            </Col>
                                            <Col xs={6} md={2}>
                                                <Form.Label className="small fw-bold mb-1">Data Fim</Form.Label>
                                                <Form.Control size="sm" type="date" value={dataFim} onChange={e => setDataFim(e.target.value)} />
                                            </Col>
                                        </>
                                    )}

                                    <Col xs={12} md={status !== 'S' ? 4 : 3}>
                                        <Button size="sm" className="w-100 fw-bold text-white" style={{ backgroundColor: '#8b0000', borderColor: '#8b0000' }} onClick={carregarPedidos} disabled={loading}>
                                            {loading ? <Spinner animation="border" size="sm" /> : <><FaSync className="me-1" /> Filtrar</>}
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Card className="border-0 shadow-sm">
                            <Card.Header className="bg-white fw-bold py-3">
                                <span>Pedidos de EPI ({pedidos.length})</span>
                            </Card.Header>

                            {loading ? (
                                <div className="text-center py-5">
                                    <Spinner animation="border" style={{ color: '#8b0000' }} />
                                    <div className="text-muted mt-2 fw-bold small">Carregando pedidos de EPI...</div>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <Table hover className="mb-0 align-middle text-center small">
                                        <thead className="table-light">
                                            <tr>
                                                <th style={{ width: '50px' }}>Foto</th>
                                                <th className="text-start">Colaborador / Função / Loja</th>
                                                <th className="text-start">EPI / Cód / Qtde</th>
                                                <th>Dt. Pedido</th>
                                                <th>Dt. Aprovado</th>
                                                <th>Dt. Recebido</th>
                                                <th>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pedidos.map((p, idx) => (
                                                <tr key={idx}>
                                                    <td>
                                                        <FotoFuncionarioAvatar
                                                            chapa={p.chapa}
                                                            nome={p.nome}
                                                            info01={`Matrícula: ${p.chapa}`}
                                                            info02={`Loja ${formatarLoja(p.loja)}`}
                                                            onSelectFoto={setFotoSelecionada}
                                                        />
                                                    </td>
                                                    <td className="text-start">
                                                        <strong>{p.nome}</strong><br />
                                                        <small className="text-muted">{p.funcao} | Loja {formatarLoja(p.loja)}</small><br />
                                                        <small className="text-secondary">Matrícula: {p.chapa}</small>
                                                    </td>
                                                    <td className="text-start">
                                                        <div className="d-flex align-items-center">
                                                            <FotoEpiAvatar
                                                                codGrupo={p.cod_grupo}
                                                                descricao={p.descricao_epi}
                                                                onSelectFoto={setFotoSelecionada}
                                                            />
                                                            <div>
                                                                <strong>{limparTextoProfundo(p.descricao_epi)}</strong><br />
                                                                <small>Cód: {p.cod_epi} | Qtd: <Badge bg="danger">{p.qtde}</Badge></small>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>{p.data_pedido || '-'}</td>
                                                    <td>{p.data_aprovado || '-'}</td>
                                                    <td>{p.data_recebido || '-'}</td>
                                                    <td>
                                                        <div className="d-flex gap-1 justify-content-center">
                                                            {p.status_cod === 'S' && (
                                                                <Button size="sm" variant="outline-success" title="Analisar/Aprovar Pedido" onClick={() => abrirModalPedido(p.pedido)}>
                                                                    <FaCheck />
                                                                </Button>
                                                            )}

                                                            {p.status_cod === 'A' && (
                                                                <Button size="sm" variant="outline-warning" title="Despachar Pedido" onClick={() => { setPedidoSelDespacho(p); setShowModalDespacho(true); }}>
                                                                    <FaTruck />
                                                                </Button>
                                                            )}

                                                            <Button size="sm" variant="outline-primary" title="Visualizar Pedido" onClick={() => abrirModalPedido(p.pedido)}>
                                                                <FaEye />
                                                            </Button>

                                                            <Button size="sm" variant="outline-secondary" title="Ver Log de Pedidos" onClick={() => abrirModalLog(p.pedido)}>
                                                                <FaHistory />
                                                            </Button>

                                                            <Button size="sm" variant="outline-dark" title="Imprimir Ficha do Funcionário" onClick={() => imprimirFichaIndividual(p.chapa, p)}>
                                                                <FaPrint />
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            {pedidos.length === 0 && (
                                                <tr>
                                                    <td colSpan="7" className="text-center py-4 text-muted">Nenhum pedido encontrado.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </Card>
                    </Tab>

                    <Tab eventKey="funcionarios" title={<><FaUserTag className="me-1" /> Funcionários por Loja e Departamento</>}>
                        <Card className="border-0 shadow-sm mb-3">
                            <Card.Body className="p-3">
                                <Row className="g-2 align-items-end">
                                    <Col xs={12} md={5}>
                                        <Form.Label className="small fw-bold">Selecione Loja ou Departamento</Form.Label>
                                        <Form.Select
                                            size="sm"
                                            value={seletorFiltro}
                                            onChange={e => setSeletorFiltro(e.target.value)}
                                        >
                                            <optgroup label="--- LOJAS ---">
                                                {listaLojas.map((l) => {
                                                    const cod = Math.floor(l.cod_emp);
                                                    return (
                                                        <option key={`loja_${cod}`} value={`LOJA_${cod}`}>
                                                            {l.razao || `Loja ${cod}`}
                                                        </option>
                                                    );
                                                })}
                                            </optgroup>
                                            <optgroup label="--- DEPARTAMENTOS ---">
                                                {DEPARTAMENTOS_LISTA.map((d) => (
                                                    <option key={`dep_${d.cod}`} value={`DEP_${d.cod}`}>
                                                        {d.nome} (Dep. {d.cod})
                                                    </option>
                                                ))}
                                            </optgroup>
                                        </Form.Select>
                                    </Col>

                                    {/* ITEM 3: CAMPO DE BUSCA LOCAL/FRONTEND */}
                                    <Col xs={12} md={4}>
                                        <Form.Label className="small fw-bold">Filtrar por Nome, Chapa ou Função</Form.Label>
                                        <div className="input-group input-group-sm">
                                            <span className="input-group-text bg-light"><FaSearch className="text-muted" /></span>
                                            <Form.Control
                                                size="sm"
                                                type="text"
                                                placeholder="Digite nome, chapa ou função..."
                                                value={termoFiltroFunc}
                                                onChange={e => setTermoFiltroFunc(e.target.value)}
                                            />
                                        </div>
                                    </Col>

                                    <Col xs={12} md={3}>
                                        <Button size="sm" className="w-100 fw-bold text-white" style={{ backgroundColor: '#8b0000', borderColor: '#8b0000' }} onClick={carregarFuncionariosLoja} disabled={loadingFuncsLoja}>
                                            {loadingFuncsLoja ? <Spinner animation="border" size="sm" /> : <><FaSync className="me-1" /> Buscar Colaboradores</>}
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Card className="border-0 shadow-sm">
                            <Card.Header className="bg-white fw-bold py-3 d-flex justify-content-between align-items-center">
                                <span>Colaboradores Selecionados ({funcionariosFiltrados.length} / {funcionariosLoja.length})</span>
                                {termoFiltroFunc && (
                                    <small className="text-muted font-normal">
                                        Filtrando por: <strong>"{termoFiltroFunc}"</strong>
                                    </small>
                                )}
                            </Card.Header>
                            {loadingFuncsLoja ? (
                                <div className="text-center py-5">
                                    <Spinner animation="border" style={{ color: '#8b0000' }} />
                                    <div className="text-muted mt-2 fw-bold small">Carregando colaboradores...</div>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <Table hover className="mb-0 align-middle small text-center">
                                        <thead className="table-light">
                                            <tr>
                                                <th style={{ width: '50px' }}>Foto</th>
                                                <th className="text-start">Matrícula / Nome</th>
                                                <th className="text-start">Função / Setor</th>
                                                <th>Dt. Admissão</th>
                                                <th>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {funcionariosFiltrados.map((f, i) => (
                                                <tr key={i}>
                                                    <td>
                                                        <FotoFuncionarioAvatar chapa={f.chapa} nome={f.nome} onSelectFoto={setFotoSelecionada} />
                                                    </td>
                                                    <td className="text-start">
                                                        <strong>{f.nome}</strong><br />
                                                        <small className="text-muted">Matrícula: {f.chapa}</small>
                                                    </td>
                                                    <td className="text-start">
                                                        <span>{f.funcao}</span><br />
                                                        <small className="text-muted">{f.setor}</small>
                                                    </td>
                                                    <td>{f.data_admissao || '-'}</td>
                                                    <td>
                                                        <div className="d-flex gap-1 justify-content-center">
                                                            <Button
                                                                size="sm"
                                                                variant="outline-primary"
                                                                className="fw-bold"
                                                                onClick={() => abrirEpisAssociados(f)}
                                                            >
                                                                <FaBoxes className="me-1" /> EPIs Associados
                                                            </Button>

                                                            <Button
                                                                size="sm"
                                                                variant="outline-dark"
                                                                className="fw-bold"
                                                                onClick={() => imprimirFichaIndividual(f.chapa, f)}
                                                            >
                                                                <FaPrint className="me-1" /> Imprimir Ficha
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            {funcionariosFiltrados.length === 0 && (
                                                <tr>
                                                    <td colSpan="5" className="text-center py-4 text-muted">
                                                        {termoFiltroFunc ? 'Nenhum colaborador encontrado com os filtros aplicados.' : 'Nenhum colaborador encontrado para a opção selecionada.'}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </Card>
                    </Tab>
                </Tabs>
            </Container>

            {/* MODAL EPIS ASSOCIADOS */}
            <Modal show={showModalEpisFunc} onHide={() => setShowModalEpisFunc(false)} size="lg" centered>
                <Modal.Header closeButton style={{ backgroundColor: '#8b0000', color: '#fff' }}>
                    <Modal.Title className="fs-6 fw-bold">
                        🪖 EPIs Associados: {funcSelecionado?.nome} ({funcSelecionado?.chapa})
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    {loadingEpisAssoc ? (
                        <div className="text-center py-4"><Spinner animation="border" style={{ color: '#8b0000' }} /></div>
                    ) : (
                        <div className="table-responsive">
                            <Table hover size="sm" className="align-middle text-center small mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th style={{ width: '50px' }}>Foto</th>
                                        <th className="text-start">EPI / Descrição</th>
                                        <th>C.A</th>
                                        <th>Qtde</th>
                                        <th>Data Solicitação</th>
                                        <th>Data Aprovação</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {episAssociados.map((item, idx) => (
                                        <tr key={idx}>
                                            <td>
                                                <FotoEpiAvatar codGrupo={item.cod_grupo} descricao={item.descricao_epi} onSelectFoto={setFotoSelecionada} />
                                            </td>
                                            <td className="text-start">
                                                <strong>{limparTextoProfundo(item.descricao_epi)}</strong><br />
                                                <small className="text-muted">Cód: {item.cod_epi}</small>
                                            </td>
                                            <td>{limparTextoProfundo(item.ca_epi) || '-'}</td>
                                            <td><Badge bg="secondary">{item.qtde}</Badge></td>
                                            <td>{item.data_solicitacao || '-'}</td>
                                            <td>{item.data_aprovado || '-'}</td>
                                            <td><Badge bg="info">{item.status}</Badge></td>
                                        </tr>
                                    ))}
                                    {episAssociados.length === 0 && (
                                        <tr>
                                            <td colSpan="7" className="text-center py-3 text-muted">Nenhum EPI associado/solicitado para este colaborador.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    <Button variant="secondary" size="sm" onClick={() => setShowModalEpisFunc(false)}>Fechar</Button>
                    {funcSelecionado && (
                        <Button variant="dark" size="sm" onClick={() => imprimirFichaIndividual(funcSelecionado.chapa, funcSelecionado)}>
                            <FaPrint className="me-1" /> Imprimir Ficha de EPI
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* MODAL DETALHES DO PEDIDO */}
            <Modal show={showModalPedido} onHide={() => setShowModalPedido(false)} size="lg" centered>
                <Modal.Header closeButton style={{ backgroundColor: '#8b0000', color: '#fff' }}>
                    <Modal.Title className="fs-6 fw-bold">📋 Pedido de EPI nº {pedidoDetalhe?.pedido}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    {loadingDetalhe ? (
                        <div className="text-center py-4"><Spinner animation="border" style={{ color: '#8b0000' }} /></div>
                    ) : pedidoDetalhe && (
                        <div className="d-flex flex-column gap-3">
                            <fieldset className="border rounded p-2">
                                <legend className="float-none w-auto px-2 fs-7 fw-bold text-uppercase text-secondary mb-0">Funcionário</legend>
                                <Row className="g-2">
                                    <Col md={3}>
                                        <Form.Label className="x-small text-muted mb-0">Chapa</Form.Label>
                                        <Form.Control size="sm" readOnly value={pedidoDetalhe.chapa} />
                                    </Col>
                                    <Col md={7}>
                                        <Form.Label className="x-small text-muted mb-0">Nome</Form.Label>
                                        <Form.Control size="sm" readOnly value={pedidoDetalhe.nome_funcionario} />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Label className="x-small text-muted mb-0">Situação</Form.Label>
                                        <Form.Control size="sm" readOnly value="A" />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Label className="x-small text-muted mb-0">Loja</Form.Label>
                                        <Form.Control size="sm" readOnly value={formatarLoja(pedidoDetalhe.loja)} />
                                    </Col>
                                    <Col md={4}>
                                        <Form.Label className="x-small text-muted mb-0">Seção</Form.Label>
                                        <Form.Control size="sm" readOnly value={pedidoDetalhe.setor} />
                                    </Col>
                                    <Col md={4}>
                                        <Form.Label className="x-small text-muted mb-0">Função</Form.Label>
                                        <Form.Control size="sm" readOnly value={pedidoDetalhe.funcao} />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Label className="x-small text-muted mb-0">Admissão</Form.Label>
                                        <Form.Control size="sm" readOnly value={pedidoDetalhe.data_admissao} />
                                    </Col>
                                </Row>
                            </fieldset>

                            <fieldset className="border rounded p-2">
                                <legend className="float-none w-auto px-2 fs-7 fw-bold text-uppercase text-secondary mb-0">EPI</legend>
                                <Row className="g-2 align-items-center">
                                    <Col md={2} className="text-center">
                                        <FotoEpiAvatar codGrupo={pedidoDetalhe.cod_grupo} descricao={pedidoDetalhe.epi_nome} onSelectFoto={setFotoSelecionada} />
                                    </Col>
                                    <Col md={10}>
                                        <Row className="g-2">
                                            <Col md={2}>
                                                <Form.Label className="x-small text-muted mb-0">Cód. Grupo</Form.Label>
                                                <Form.Control size="sm" readOnly value={pedidoDetalhe.cod_grupo} />
                                            </Col>
                                            <Col md={8}>
                                                <Form.Label className="x-small text-muted mb-0">Grupo</Form.Label>
                                                <Form.Control size="sm" readOnly value={limparTextoProfundo(pedidoDetalhe.grupo_nome)} />
                                            </Col>
                                            <Col md={2}>
                                                <Form.Label className="x-small text-muted mb-0">Cor</Form.Label>
                                                <Form.Control size="sm" readOnly value={pedidoDetalhe.cor || '-'} />
                                            </Col>

                                            <Col md={3}>
                                                <Form.Label className="x-small text-muted mb-0">Cód. EPI</Form.Label>
                                                <div className="d-flex gap-1">
                                                    <Form.Control
                                                        size="sm"
                                                        readOnly={!editandoCodEpi}
                                                        value={editandoCodEpi ? novoCodEpi : pedidoDetalhe.cod_epi}
                                                        onChange={e => setNovoCodEpi(e.target.value)}
                                                        className={editandoCodEpi ? "border-danger fw-bold" : ""}
                                                    />
                                                    {pedidoDetalhe.status === 'S' && (
                                                        <Button
                                                            size="sm"
                                                            variant={editandoCodEpi ? "success" : "outline-secondary"}
                                                            onClick={() => {
                                                                if (editandoCodEpi) handleSalvarNovoEpi();
                                                                else setEditandoCodEpi(true);
                                                            }}
                                                        >
                                                            <FaEdit />
                                                        </Button>
                                                    )}
                                                </div>
                                            </Col>

                                            <Col md={7}>
                                                <Form.Label className="x-small text-muted mb-0">EPI</Form.Label>
                                                <Form.Control size="sm" readOnly value={limparTextoProfundo(pedidoDetalhe.epi_nome)} />
                                            </Col>
                                            <Col md={2}>
                                                <Form.Label className="x-small text-muted mb-0">Status</Form.Label>
                                                <Form.Control size="sm" readOnly value={pedidoDetalhe.status} />
                                            </Col>

                                            {editandoCodEpi && (
                                                <Col md={12} className="bg-light p-2 rounded border mt-2">
                                                    <Form.Label className="small fw-bold mb-1 text-danger">Buscar/Substituir Equipamento</Form.Label>
                                                    <div className="d-flex gap-2 mb-2">
                                                        <Form.Control
                                                            size="sm"
                                                            type="text"
                                                            placeholder="Digite código ou nome do EPI..."
                                                            value={buscaEpiTermo}
                                                            onChange={e => pesquisarEpis(e.target.value)}
                                                        />
                                                    </div>
                                                    {loadingBuscaEpi ? (
                                                        <Spinner animation="border" size="sm" style={{ color: '#8b0000' }} />
                                                    ) : (
                                                        listaEpisBusca.length > 0 && (
                                                            <div className="list-group border rounded style-scroll" style={{ maxHeight: '120px', overflowY: 'auto' }}>
                                                                {listaEpisBusca.map((item) => (
                                                                    <button
                                                                        key={item.cod_epi}
                                                                        type="button"
                                                                        className="list-group-item list-group-item-action p-1 small d-flex justify-content-between align-items-center"
                                                                        onClick={() => {
                                                                            setNovoCodEpi(item.cod_epi);
                                                                            handleSalvarNovoEpi(item.cod_epi);
                                                                        }}
                                                                    >
                                                                        <span><strong>[{item.cod_epi}]</strong> {limparTextoProfundo(item.descricao)}</span>
                                                                        <Badge bg="secondary">Selecionar</Badge>
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        )
                                                    )}
                                                </Col>
                                            )}

                                            <Col md={3}>
                                                <Form.Label className="x-small text-muted mb-0">Estoque</Form.Label>
                                                <Form.Control size="sm" readOnly value={pedidoDetalhe.estoque} />
                                            </Col>
                                            <Col md={3}>
                                                <Form.Label className="x-small text-muted mb-0">Custo</Form.Label>
                                                <Form.Control size="sm" readOnly value={Number(pedidoDetalhe.epi_custo || 0).toFixed(2)} />
                                            </Col>
                                            <Col md={3}>
                                                <Form.Label className="x-small text-muted mb-0">Vida Útil</Form.Label>
                                                <Form.Control size="sm" readOnly value={pedidoDetalhe.vidautil} />
                                            </Col>
                                            <Col md={3}>
                                                <Form.Label className="x-small text-muted mb-0">CA</Form.Label>
                                                <Form.Control size="sm" readOnly value={limparTextoProfundo(pedidoDetalhe.ca) || '-'} />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </fieldset>

                            <fieldset className="border rounded p-2">
                                <legend className="float-none w-auto px-2 fs-7 fw-bold text-uppercase text-secondary mb-0">Pedido</legend>
                                <Row className="g-2">
                                    <Col md={2}>
                                        <Form.Label className="x-small text-muted mb-0">Código</Form.Label>
                                        <Form.Control size="sm" readOnly value={pedidoDetalhe.pedido} />
                                    </Col>
                                    <Col md={4}>
                                        <Form.Label className="x-small text-muted mb-0">Data Pedido</Form.Label>
                                        <Form.Control size="sm" readOnly value={pedidoDetalhe.data_pedido} />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label className="x-small text-muted mb-0">Motivo</Form.Label>
                                        <Form.Control size="sm" readOnly value={pedidoDetalhe.motivo} />
                                    </Col>

                                    <Col md={8}>
                                        <Form.Label className="x-small text-muted mb-0">Solicitante</Form.Label>
                                        <Form.Control size="sm" readOnly value={pedidoDetalhe.solicitante} />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Label className="x-small text-muted mb-0">Custo</Form.Label>
                                        <Form.Control size="sm" readOnly value={Number(pedidoDetalhe.custo || 0).toFixed(2)} />
                                    </Col>

                                    <Col md={2}>
                                        <Form.Label className="x-small text-muted mb-0">Quantidade</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="number"
                                            readOnly={pedidoDetalhe.status !== 'S'}
                                            value={pedidoDetalhe.status === 'S' ? qtdAprovacao : pedidoDetalhe.qtde}
                                            onChange={e => setQtdAprovacao(e.target.value)}
                                        />
                                    </Col>

                                    <Col md={12}>
                                        <Form.Label className="x-small text-muted mb-0">Observação</Form.Label>
                                        <Form.Control size="sm" readOnly value={pedidoDetalhe.observacao || ''} />
                                    </Col>
                                </Row>
                            </fieldset>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    <Button variant="secondary" size="sm" onClick={() => setShowModalPedido(false)}>Fechar</Button>

                    {pedidoDetalhe?.status === 'S' && (
                        <div className="d-flex gap-2">
                            <Button variant="danger" size="sm" onClick={() => handleAprovarNegar('N')}>
                                <FaTimes className="me-1" /> Negar
                            </Button>
                            <Button variant="success" size="sm" onClick={() => handleAprovarNegar('A')}>
                                <FaCheck className="me-1" /> Aprovar
                            </Button>
                        </div>
                    )}
                </Modal.Footer>
            </Modal>

            {/* MODAL DE LOG DO PEDIDO */}
            <Modal show={showModalLog} onHide={() => setShowModalLog(false)} size="lg" centered>
                <Modal.Header closeButton style={{ backgroundColor: '#8b0000', color: '#fff' }}>
                    <Modal.Title className="fs-6 fw-bold">📜 Log do Pedido</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    {loadingLog ? (
                        <div className="text-center py-4"><Spinner animation="border" style={{ color: '#8b0000' }} /></div>
                    ) : dadosLog && (
                        <div className="d-flex flex-column gap-3">
                            <Row className="g-2">
                                <Col md={3}>
                                    <Form.Label className="x-small text-muted mb-0">Chapa</Form.Label>
                                    <Form.Control size="sm" readOnly value={dadosLog.chapa} className="bg-success text-white fw-bold" />
                                </Col>
                                <Col md={9}>
                                    <Form.Label className="x-small text-muted mb-0">Nome</Form.Label>
                                    <Form.Control size="sm" readOnly value={dadosLog.nome} />
                                </Col>

                                <Col md={2}>
                                    <Form.Label className="x-small text-muted mb-0">Código</Form.Label>
                                    <Form.Control size="sm" readOnly value={dadosLog.cod_epi} />
                                </Col>
                                <Col md={6}>
                                    <Form.Label className="x-small text-muted mb-0">Epi</Form.Label>
                                    <Form.Control size="sm" readOnly value={limparTextoProfundo(dadosLog.epi_nome)} />
                                </Col>
                                <Col md={2}>
                                    <Form.Label className="x-small text-muted mb-0">Qtde</Form.Label>
                                    <Form.Control size="sm" readOnly value={dadosLog.qtde} />
                                </Col>
                                <Col md={2}>
                                    <Form.Label className="x-small text-muted mb-0">Custo</Form.Label>
                                    <Form.Control size="sm" readOnly value={Number(dadosLog.custo || 0).toFixed(2)} />
                                </Col>

                                <Col md={12}>
                                    <Form.Label className="x-small text-muted mb-0">Motivo</Form.Label>
                                    <Form.Control size="sm" readOnly value={dadosLog.motivo} />
                                </Col>
                            </Row>

                            <div className="table-responsive border rounded mt-2">
                                <Table hover size="sm" className="mb-0 text-start align-middle x-small">
                                    <thead className="table-light">
                                        <tr>
                                            <th style={{ width: '40px' }}>Sts</th>
                                            <th>Data do Pedido</th>
                                            <th>Usuário</th>
                                            <th className="text-center">Qtde</th>
                                            <th className="text-end">Custo</th>
                                            <th>Movimentação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(dadosLog.historico_log || []).map((h, i) => (
                                            <tr key={i} className={i === 0 ? "table-success fw-bold" : ""}>
                                                <td><Badge bg={h.sts === 'S' ? 'success' : h.sts === 'N' ? 'danger' : 'secondary'}>{h.sts}</Badge></td>
                                                <td>{h.data_pedido}</td>
                                                <td>{h.usuario}</td>
                                                <td className="text-center">{h.qtde}</td>
                                                <td className="text-end">{Number(h.custo || 0).toFixed(2)}</td>
                                                <td>{h.movimentacao}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={() => setShowModalLog(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL DESPACHO */}
            <Modal show={showModalDespacho} onHide={() => setShowModalDespacho(false)} centered>
                <Modal.Header closeButton style={{ backgroundColor: '#8b0000', color: '#fff' }}>
                    <Modal.Title className="fs-6 fw-bold">Despachar Pedido nº {pedidoSelDespacho?.pedido}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="g-2">
                        <Col md={6}>
                            <Form.Label className="small fw-bold">CGO</Form.Label>
                            <Form.Control size="sm" type="text" value={cgo} onChange={e => setCgo(e.target.value)} />
                        </Col>
                        <Col md={6}>
                            <Form.Label className="small fw-bold">Nota Fiscal</Form.Label>
                            <Form.Control size="sm" type="text" value={nota} onChange={e => setNota(e.target.value)} />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={() => setShowModalDespacho(false)}>Cancelar</Button>
                    <Button size="sm" className="fw-bold text-white" style={{ backgroundColor: '#8b0000', borderColor: '#8b0000' }} onClick={handleConfirmarDespacho}>
                        <FaTruck className="me-1" /> Despachar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Footer />

            <Foto
                show={!!fotoSelecionada}
                onClose={() => setFotoSelecionada(null)}
                foto={fotoSelecionada?.foto}
                nome={fotoSelecionada?.nome}
                info01={fotoSelecionada?.info01}
                info02={fotoSelecionada?.info02}
            />
        </div>
    );
}